import { useFeatureToggle } from '@bizzabo/feature-toggle-client';
import useRingFeature from './useRingFeature';

/**
 * Query the status of a feature controlled by LaunchDarkly and the Bizzabo dashboard
 * @param eventUniqueName Event unique name
 * @param toggleName LaunchDarkly feature toggle name
 * @param ringFeatureName Bizzabo dashboard feature toggle name
 */
const useLDRingFeature = (eventUniqueName: string, toggleName: string, ringFeatureName: string) => {
    const toggleEnabled = useFeatureToggle(toggleName);
    const { isLoading: isLoadingRingFeature, data: ringFeatureEnabled } = useRingFeature(
        eventUniqueName,
        ringFeatureName
    );

    return {
        data: toggleEnabled && ringFeatureEnabled,
        isLoading: isLoadingRingFeature,
    };
};

export default useLDRingFeature;
